function LoginCard({ children }) {
	return (
		<div className="login-page">
			<div className="login-card">{children}</div>
		</div>
	);
}

export default LoginCard;
